import { m } from "framer-motion";
import { getUrqlClient } from "@/lib/urql-client";
import { QUERY_ENDPOINTS } from "@/framework/utils/query-endpoints";
import { sanitize } from "@/framework/utils/sanitize";
import Banner from "@/components/pages/process/banner";
import { fadeIn } from "@/utils/motion/fade-in";
// import CircularImage from "@/components/pages/process/circular-image";
// import Openings from "@/components/pages/process/openings";
import Values from "@/components/pages/process/values";
// import CherishedMoments from "@/components/pages/process/cherished-moments";
import Seo from "@/utils/seo";
// import ChalkingItOut from "@/components/pages/process/chalking-it-out";
import { CURRENT_OPENING_IMAGE_QUERY } from "@/framework/queries/currentOpeningsImage";
import { CAREERS_LETS_TALK_QUERY } from "@/framework/queries/careersletstalk";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const ChalkingItOut = dynamic(() => import("@/components/pages/process/chalking-it-out"), { ssr: false, });
const CircularImage = dynamic(() => import("@/components/pages/process/circular-image"), { ssr: false, });
const CherishedMoments = dynamic(() => import("@/components/pages/process/cherished-moments"), { ssr: false, });
const Openings = dynamic(() => import("@/components/pages/process/openings"), { ssr: false });

const seo = {
  slug: "careers",
  metaTitle: "Chalk Studio – Interior Design Career Opportunities",
  metaDescription:
    "Join the team at Chalk Studio. Explore exciting career opportunities in interior design and grow with a dynamic, creative workplace.",
};

export default function Careers({ jobOpenings, currentOpeningsImage, careersLetsTalks }) {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(true);
    };
    const resetScrollState = () => {
      setIsScrolled(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      resetScrollState(); // Reset state when component unmounts (e.g., navigate to another page)
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Seo seo={seo} />
      <m.div
        initial="from"
        whileInView={"to"}
        viewport={{ once: true }}
        variants={fadeIn()}
      >
        <Banner
          tag="Gurugram"
          title="Explore design careers at Chalk Studio shaped by innovation, collaboration, and passion."
          description="28°41’ N, 77°08’E"
          video="/videos/M3M-8A.mp4"
        />
        <Values />
        {isScrolled && (
          <>
            <ChalkingItOut />
            <CircularImage careersLetsTalks={careersLetsTalks} />
            <CherishedMoments />
            <Openings jobOpenings={{ jobOpenings, currentOpeningsImage }} />
          </>
        )}
      </m.div>
    </>
  );
}
export async function getStaticProps({ params }) {
  const client = await getUrqlClient();
  let jobOpenings = null;
  let careersLetsTalks = null;
  let currentOpeningsImage = null;

  try {
    const careersletstalkResponse = await client.query(
      CAREERS_LETS_TALK_QUERY,
      {
        start: 0,
        limit: 8,
        sortBy: ["id:asc"],
        filter: {},
      },
      { requestPolicy: "network-only" }
    );
    /*  careersLetsTalks = careersletstalkResponse.data?.careersLetsTalks?.data?.attributes || null;
      console.log("careersLetsTalks Response:", careersletstalkResponse);*/

    careersLetsTalks = careersletstalkResponse.data?.careersLetsTalks?.data || [];
    console.log("careersLetsTalks:", careersLetsTalks);

    const currentOpeningsImageResponse = await client.query(
      CURRENT_OPENING_IMAGE_QUERY, {}, {
      requestPolicy: "network-only",
    });
    currentOpeningsImage = currentOpeningsImageResponse.data?.currentOpeningsImage?.data?.attributes || null;
    const { data } = await client.query(
      QUERY_ENDPOINTS.ALL_JOBS,
      {
        start: 0,
        limit: 12,
        sortBy: ["order:asc"],
        filter: {},
      },
      { requestPolicy: "network-only" }
    );

    jobOpenings = data?.jobOpenings?.data.map((row) => sanitize(row)) || [];
  } catch (err) {
    console.log(err);
  }
  return {
    props: {
      jobOpenings: jobOpenings ?? {},
      currentOpeningsImage: currentOpeningsImage ?? {},
      careersLetsTalks: careersLetsTalks ?? {},
    },
    revalidate: 604800, // In seconds
  };
}
